import React, { useState } from "react";
import axios from "axios";
import { decodeToken } from "../utilities/auth";
import logo from "../assets/Logo.png";
import "../Style/Login.css";

const ROLE_LABELS = {
    admin: "Ադմինիստրատոր",
    manager: "Մենեջեր",
};

const Login = ({ role }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError]       = useState("");
    const [loading, setLoading]   = useState(false);

    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const endpoint =
                role === "admin"
                    ? `${API_URL}/auth/admin-login`
                    : `${API_URL}/auth/manager-login`;

            const response = await axios.post(endpoint, { username, password });

            if (response.data.success && response.data.token) {
                const payload    = decodeToken(response.data.token);
                const actualRole = payload?.role;

                localStorage.setItem("token", response.data.token);

                if (actualRole) {
                    window.location.href = `/${actualRole}`;
                } else {
                    setError("Token-ը սխալ ձևաչափով է։");
                }
            } else {
                setError(response.data.message || "Սխալ մուտքանուն կամ գաղտնաբառ");
            }
        } catch (err) {
            setError(err.response?.data?.message || "Սերվերի սխալ");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <img src={logo} alt="Sovorir IT" />
                </div>

                <div>
                    <h2 className="login-title">{ROLE_LABELS[role] || "Մուտք"}</h2>
                    <p className="login-subtitle">Sovorir IT կառավարման համակարգ</p>
                </div>

                {error && <div className="login-error">{error}</div>}

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="login-field">
                        <label htmlFor="login-username">Մուտքանուն</label>
                        <input
                            id="login-username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Մուտքագրեք մուտքանունը"
                            required
                            autoComplete="username"
                        />
                    </div>

                    <div className="login-field">
                        <label htmlFor="login-password">Գաղտնաբառ</label>
                        <input
                            id="login-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Մուտքագրեք գաղտնաբառը"
                            required
                            autoComplete="current-password"
                        />
                    </div>

                    <button
                        type="submit"
                        className="login-btn"
                        disabled={loading}
                    >
                        {loading ? "Բեռնվում է..." : "Մուտք"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
